import React, { useState, useEffect } from 'react';
import { BsMoon, BsBrightnessHigh } from "react-icons/bs";

const ThemesToggle = () => {
  const [theme, setTheme] = useState(() => {
    // Get initial theme from localStorage or default to light
    return localStorage.getItem('theme') || 'light';
  });

  // Set theme attribute and localStorage on mount
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme', newTheme);
  };

  return (
    <div>
      <button
        id="theme-toggle"
        className="btn theme_switch m-0"
        type="button"
        onClick={toggleTheme}
      >
        {theme === 'light' ? (
          <span className="dark"><BsMoon /></span>
        ) : (
          <span className="light"><BsBrightnessHigh /></span>
        )}
      </button>
    </div>
  );
};

export default ThemesToggle;
